export default () => ({
	pageLoader: false,
	closeWarning: null,
	loadingOverlay: {active: false, message: ''},
	wsState: 'disconnected',
	authenticationExecuted: false,
	apiErrorModalConfig: {active: false, title: '', text: '', buttonText: '', redirectRoute: ''},
	inlineNotificationModalConfig: {duration: 0, type: 'success', message: ''},
});
